import { apiClient } from './axios';
import { PaginationData } from '../models/paginationData';
import type { InquiryItem, InquiryDetail, InquirySummary, InquiryFilterParams } from '../types/inquiry';

export const inquiryApi = {
    getInquiries: async (params: InquiryFilterParams) => {
        const result = await apiClient.get<PaginationData<InquiryItem>>('/admin/inquiries', {
            page: params.page - 1,
            size: params.size,
            ...(params.status ? { status: params.status } : {}),
            ...(params.category ? { category: params.category } : {}),
            ...(params.keyword ? { keyword: params.keyword } : {}),
        });
        return { ...result, content: result.content ?? [] };
    },

    getSummary: () =>
        apiClient.get<InquirySummary>('/admin/inquiries/summary'),

    getDetail: (id: number) =>
        apiClient.get<InquiryDetail>(`/admin/inquiries/${id}`),

    answer: (id: number, answer: string) =>
        apiClient.post<InquiryDetail>(`/admin/inquiries/${id}/answer`, { answer }),

    changeStatus: (id: number, status: string) =>
        apiClient.patchNoData(`/admin/inquiries/${id}/status`, { status }),
};
